import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
var microchipCheckerEl = document.getElementById('v-microchip-checker')
export default Vue.component(
  'microchip-checker',
  {
    data () {
      return {
        fields: {
          microchipNumber: '',
          token: microchipCheckerEl.dataset && microchipCheckerEl.dataset.token
        },
        loading: false,
        microchipExists: null,
        success: false,
        errorMessage: null
      }
    },
    methods: {
      sendVerificationEmail () {
        const url = '/api/microchip/verification/' + this.fields.microchipNumber + '?token=' + this.fields.token
        this.errorMessage = null
        this.loading = true
        this.success = false
        this.microchipExists = null
        this.axios({
          url,
          maxRedirects: 0
        }).then((res) => {
          this.loading = false
          this.success = true
          this.microchipExists = res?.data?.message || 'An issue occurred, please refresh and try again, or contact us'
        }).catch((err) => {
          this.loading = false
          this.success = false
          this.errorMessage = err?.response?.data?.errors?.[0]?.value || 'An unknown error occurred, please refresh or try again later'
        })
      },
      submitCheck (e) {
        e.preventDefault()
        this.errorMessage = null
        this.loading = true
        this.success = false
        this.microchipExists = false

        const url = '/api/microchip/exists/' + this.fields.microchipNumber + '?token=' + this.fields.token
        this.axios({
          url,
          maxRedirects: 0
        }).then((res) => {
          this.loading = false
          this.success = true
          this.microchipExists = res?.data?.message || 'An issue occurred, please refresh and try again, or contact us'
        }).catch((err) => {
          this.loading = false
          this.success = false
          this.errorMessage = err?.response?.data?.errors?.microchipNumber?.value || 'An unknown error occurred, please refresh or try again later'
        })
      }
    }
  }
)
